module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "page_36"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('h2', {
    staticClass: "chapnum"
  }, [_vm._v("8")]), _vm._v(" "), _c('h2', {
    staticClass: "chaptitle"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("The Bronze Watch Bell from the")]), _vm._v(" Mary Rose")])]), _vm._v(" "), _c('h3', {
    staticClass: "sub_section"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Construction of the")]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Mary Rose")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Threatened with invasion by France and Scotland, Henry VIII ordered the construction of the")]), _vm._v(" Mary Rose "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("within a year of his coronation. Henry named her Mary after his sister and she was built in Portsmouth dockyard (close to where she is now displayed) during 1510. The ship’s bell of the")]), _vm._v(" Mary Rose "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("was cast in 1510 and is one of the few objects that remained with the ship throughout its career which spanned thirty-four years until she sank in 1545")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("Henry VIII ordered the renovation of the ship "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Sovereign")]), _vm._v(" and the construction of two new vessels that were named the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Mary Rose")]), _vm._v(" and the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Peter Pomegranate")]), _vm._v(" (referred to as the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Peter Granade")]), _vm._v(" during that period) in Portsmouth dockyard. The first record of the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Mary Rose")]), _vm._v(" appeared in state records on 29 July 1511, a payment to ‘Robt. Brygandyne, clerk of the King’s ships, for the conveyance of two new ships, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Mary Rose")]), _vm._v(" and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Peter Granade")]), _vm._v(", from Portsmouth to the Thames.’"), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/107_Notes#rfnch08_14",
      "id": "fnch08_14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14")])]), _vm._v(" This reference probably related to the maiden voyage of the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Mary Rose")]), _vm._v(", commanded by her first master Thomas Spert. Further payments were made to Brygandyne in September 1511 for expenses relating to these vessels, once they had arrived in the River Thames. In October 1511 payments were made relating to stocking ordnance aboard the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Mary Rose")]), _vm._v(" and the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Peter Granade")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In 1512, the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Mary Rose")]), _vm._v(" displaced 600 tons and was manned by 120 sailors, 251 soldiers and 20 gunners, 2 pilots, 5 trumpeters and 36 servants. She was armed with 43 heavy guns and 37 small guns. She was rebuilt in 1536, weighed 700 tons, carried 71 guns and was able to fire broadsides and was classified as one of the first sailing wooden warships.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Mary Rose")]), _vm._v(" participated in two battles, at Saint-Mathieu, near Brest in 1512, which was possibly the first battle fought at sea where guns were fired through gun-ports, and the Battle of Solent in 1545. The vessel became a favourite of Henry VIII and accompanied him as escort when he sailed across the English Channel on his journey to meet King Francis I of France at the Field of the Cloth of Gold in June 1520.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0036-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("The ship’s bell from the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Mary Rose")]), _vm._v(". (Author’s Collection)")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_37"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0037-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Model of the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Mary Rose")]), _vm._v(". (Author’s Collection)")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Mary Rose’s")]), _vm._v(" bell was cast in Malines, near Antwerp, and remained with her throughout her service. Made of bronze and weighing 5kg, the Flemish inscription skirting the top of the bell states, ‘I was made in the year 1510’, as the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Mary Rose")]), _vm._v(" was being built. Its primary purpose was to alert the ship’s company to the time to enable them to know when to change watch and to give an indication of time during that watch. For instance, at 8am the bell would be rung eight times on that hour, and would be rung every half an hour until the end of the watch at midday. At 8.30am it would be rung once, followed half an hour later with two rings, then three rings on the next half an hour until midday when eight bells were rung, denoting the end of the watch and the process would begin once again for the following watch. The bell was also regularly used in fog to alert other nearby ships of the ship’s presence.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0037-02.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("The Anthony Roll was compiled in 1540 and is a list of all Henry VIII’s vessels within the navy, recording the names, tonnage, dimensions and crew members of each vessel. This is the only contemporary image of the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Mary Rose")]), _vm._v(", showing a carrack design with high castles fore and aft. Despite the fact that the position of the gun-ports and the number of guns is not entirely accurate, this is a reasonably accurate interpretation of the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Mary Rose")]), _vm._v(". (Public Domain)")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6695b796","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/014_Chapter008.vue
// module id = 99
// module chunks = 0